import React from "react";
import { useNavigate } from "react-router-dom";

const PackageCard = ({ name, unit, price, packageId, duration, isPopular, setSelectedPackageName }) => {
  const navigate = useNavigate();

  // Clean up unit string (remove extra spaces)
  const cleanUnit = unit ? unit.trim() : "0";

  return (
    <div
      className={`relative overflow-hidden rounded-2xl p-8 shadow-lg transition-all duration-300 hover:shadow-2xl hover:translate-y-[-4px] ${
        isPopular
          ? "bg-gradient-to-br from-red-50 to-red-100 border-2 border-red-600"
          : "border border-gray-200 hover:border-red-200 bg-white"
      }`}
    >
      {isPopular && (
        <div className="absolute top-6 -right-12 px-12 py-1 text-sm font-semibold text-white bg-red-600 shadow-md rotate-45">
          Popular
        </div>
      )}
      <div className="flex flex-col gap-6">
        <h3 className="text-2xl font-bold text-gray-800">{name}</h3>
        
        <div className="flex gap-1 items-baseline">
          <span className="text-4xl font-extrabold text-red-600">
            GH₵{price}
          </span>
        </div>

        {/* Duration Badge */}
        <div className="inline-flex self-start px-3 py-1 text-xs font-semibold text-red-600 bg-red-100 rounded-full">
          {duration}
        </div>

        <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-gray-300 to-transparent my-2"></div>
        
        <div>
          <p className="mb-3 font-medium text-gray-700">Features:</p>
          <ul className="space-y-3">
            <li className="flex gap-3 items-center">
              <div className="flex justify-center items-center p-1 bg-red-100 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 text-red-600"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <span className="text-gray-700">
                {cleanUnit} SMS Units
              </span>
            </li>
            <li className="flex gap-3 items-center">
              <div className="flex justify-center items-center p-1 bg-red-100 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 text-red-600"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <span className="text-gray-700">24/7 Support</span>
            </li>
          </ul>
        </div>
        
        <button
          onClick={() => navigate("/login")}
          className={`mt-4 py-3 px-6 rounded-xl font-semibold text-center transition-all duration-300 ${
            isPopular
              ? "text-white bg-red-600 shadow-lg hover:bg-red-700 shadow-red-200 hover:shadow-xl"
              : "text-gray-800 bg-gray-100 hover:bg-red-50 hover:text-red-600"
          }`}
        >
          Choose {name}
        </button>
      </div>
    </div>
  );
};

export default PackageCard;